import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Projects',
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'projects',
                },
              },
              subqueries: {
                projects: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'piIds',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                      {
                        '!=': [
                          {
                            '@': 'organizations',
                          },
                          {
                            '[]': [],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!projects:!proj',
                  subqueries: {
                    piIds: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              {
                                '@.': '!id',
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!personnel:!employee',
                    },
                    organizations: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!org',
                      },
                      filter: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'shouldAnalyze',
                                  },
                                },
                                true,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '@.': '!should_analyze',
                                },
                                true,
                              ],
                            },
                          ],
                          true,
                        ],
                      },
                      target: 'dim::!org',
                      selection: {
                        '@.': '!id',
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: {
                                    '``': {
                                      '@$': 'orgEntityId',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '!=': [
                          {
                            '@': 'piIds',
                          },
                          null,
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '@.': '!research_type_wfuhs',
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    '!=': [
                      {
                        '@': 'organizations',
                      },
                      {
                        '[]': [],
                      },
                    ],
                  },
                ],
              },
              period: {
                '``': {
                  '@$': 'focusedRange',
                },
              },
              target: 'ent:!projects:!proj',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      id: {
                        '{}': {
                          value: {
                            '@.': '!id',
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      mtdcAvg: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'glExpensesInMtdcInLastThreeYears',
                                    },
                                  },
                                  0,
                                ],
                              },
                              3,
                            ],
                          },
                        },
                      },
                      sponsor: {
                        '{}': {
                          value: {
                            '@': 'sponsor',
                          },
                        },
                      },
                      tdcExpense: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'glExpenses',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      mtdcExpense: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '@': 'glExpensesInMtdc',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                award: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!award',
                  },
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                          null,
                        ],
                      },
                      {
                        in: [
                          {
                            '@.': '!research_type_wfuhs',
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'researchType',
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!awards:!award',
                  selection: {
                    '@.': '!budget',
                  },
                },
                piIds: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!pi',
                  },
                  using: 'projectPiAssignments',
                  filter: {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'piRecordId',
                            },
                          },
                          {
                            '@.': '!id',
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '@.': '!id',
                  },
                },
                sponsor: {
                  ref: {
                    attr: 'attr:ent#!awards#!award:!sponsor',
                  },
                  using: 'award',
                  target: 'ent:!sponsors:!sponsor',
                  selection: {
                    '@.': '!name',
                  },
                },
                glExpenses: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                },
                organizations: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!org',
                  },
                  filter: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '``': {
                                '@$': 'shouldAnalyze',
                              },
                            },
                            true,
                          ],
                        },
                        {
                          '=': [
                            {
                              '@.': '!should_analyze',
                            },
                            true,
                          ],
                        },
                      ],
                      true,
                    ],
                  },
                  target: 'dim::!org',
                  selection: {
                    '@.': '!id',
                  },
                },
                piDepartments: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!pi',
                  },
                  using: 'projectPiAssignments',
                  target: 'ent:!personnel:!employee',
                  selection: {
                    '@.': [
                      '!org',
                      {
                        ref: {
                          entity: '!dept',
                        },
                      },
                    ],
                  },
                },
                glExpensesInMtdc: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  filter: {
                    '@': 'isInMtdc',
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                  },
                },
                projectPiAssignments: {
                  ref: {
                    attr: 'attr:ent#!proj_pis#!entry:!proj',
                  },
                  target: 'ent:!proj_pis:!entry',
                },
                glExpensesInMtdcInLastThreeYears: {
                  ref: {
                    attr: 'attr:ent#!gl_exp#!entry:!proj',
                  },
                  filter: {
                    '@': 'isInMtdc',
                  },
                  period: {
                    $range: {
                      end: {
                        $date: '12/31/2024',
                      },
                      start: {
                        $date: '1/1/2022',
                      },
                    },
                  },
                  target: 'ent:!gl_exp:!entry',
                  selection: {
                    '@.': '!amount',
                  },
                  subqueries: {
                    isInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!acct',
                      },
                      target: 'ent:!gl_accts:!acct',
                      selection: {
                        '@.': '!is_in_mtdc',
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  direct: {
                    '{}': {
                      name: 'Code',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'sponsor',
                  direct: {
                    '{}': {
                      name: 'Sponsor',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'tdcExpense',
                  direct: {
                    '{}': {
                      name: 'TDC',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'mtdcExpense',
                  direct: {
                    '{}': {
                      name: 'MTDC',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'mtdcAvg',
                  direct: {
                    '{}': {
                      name: 'MTDC Average',
                      type: 'CURRENCY',
                    },
                  },
                },
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      code: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      name: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      mtdcAvg: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcInLastThreeYears',
                                      ],
                                    },
                                  ],
                                },
                              },
                              3,
                            ],
                          },
                        },
                      },
                      tdcExpense: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdcExpense',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      mtdcExpense: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdcExpense',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: {
                                        '``': {
                                          '@$': 'orgEntityId',
                                        },
                                      },
                                    },
                                  },
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '!=': [
                              {
                                '@': 'piIds',
                              },
                              null,
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': '!research_type_wfuhs',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '!=': [
                          {
                            '@': 'organizations',
                          },
                          {
                            '[]': [],
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '{}': {
                      tdcExpense: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpenses',
                            },
                          },
                          0,
                        ],
                      },
                      mtdcExpense: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpensesInMtdc',
                            },
                          },
                          0,
                        ],
                      },
                      mtdcInLastThreeYears: {
                        '??': [
                          {
                            '+': {
                              '@': 'glExpensesInMtdcInLastThreeYears',
                            },
                          },
                          0,
                        ],
                      },
                    },
                  },
                  subqueries: {
                    award: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!award',
                      },
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': '!research_type_wfuhs',
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'researchType',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!awards:!award',
                      selection: {
                        '@.': '!budget',
                      },
                    },
                    piIds: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      using: 'projectPiAssignments',
                      filter: {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              {
                                '@.': '!id',
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!personnel:!employee',
                      selection: {
                        '@.': '!id',
                      },
                    },
                    sponsor: {
                      ref: {
                        attr: 'attr:ent#!awards#!award:!sponsor',
                      },
                      using: 'award',
                      target: 'ent:!sponsors:!sponsor',
                      selection: {
                        '@.': '!name',
                      },
                    },
                    glExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                    },
                    organizations: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!org',
                      },
                      filter: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'shouldAnalyze',
                                  },
                                },
                                true,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '@.': '!should_analyze',
                                },
                                true,
                              ],
                            },
                          ],
                          true,
                        ],
                      },
                      target: 'dim::!org',
                      selection: {
                        '@.': '!id',
                      },
                    },
                    piDepartments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!pi',
                      },
                      using: 'projectPiAssignments',
                      target: 'ent:!personnel:!employee',
                      selection: {
                        '@.': [
                          '!org',
                          {
                            ref: {
                              entity: '!dept',
                            },
                          },
                        ],
                      },
                    },
                    glExpensesInMtdc: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      filter: {
                        '@': 'isInMtdc',
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                    glExpensesInMtdcInLastThreeYears: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      filter: {
                        '@': 'isInMtdc',
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2024',
                          },
                          start: {
                            $date: '1/1/2022',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
    researchType: ['BASIC RESEARCH'],
    shouldAnalyze: true,
  },
}
